'use client'

import Image from 'next/image';
import Link from 'next/link';
import React,{ useState,useEffect } from 'react'
import { useRouter } from 'next/navigation';



const Header=({DownwebLinlk,yun}:any)=>{


const router =useRouter()

    const meaus=[
        {
            title:"首页",
            id:1,
            href:"/m"
        },
        {
            title:"关于捷宸",
            id:2,
            href:"/m/about"
        },
        {
            title:"产品中心",
            id:3,
            href:"/m/product"
        },
        {
            title:"行业应用",
            id:4,
            href:"/m/application"
        }, 
        {
            title:"新闻资讯",
            id:5,
            href:"/m/news"
        }, 
        {
            title:"软件下载",
            href:"/m/filedownload",
            id:6,
        },
        {
            title:"云平台",
            id:7,
            href:`${yun}`
        },
        {
            title:"联系我们",
            id:8,
            href:"/m/contact"
        },
    ]

    const [meaul,_] = useState(meaus)

    useEffect(() => {
		import('preline');
	}, []);


  const CloseHandleEvent=(item:any)=>{
    router.push(item.href)
    const modalEl = document.getElementById('navbar-collapse-with-animation');
    window.HSCollapse.hide(modalEl);
    
  }

    return (
        <>
          <div>
            <header className="flex flex-wrap sm:justify-start sm:flex-nowrap  w-full bg-white text-sm py-4 dark:bg-gray-800 shadow-[0_0_1rem_rgba(0,0,0,.1)] ">
                    <nav className="max-w-[85rem] w-full mx-auto px-4 sm:flex sm:items-center sm:justify-between" aria-label="Global">
                        <div className="flex items-center justify-between">
                            <Image src="/m_img/logo.png"width={290}height={32}alt=""/>
                            <div className="sm:hidden">
                                <button type="button" className="hs-collapse-toggle p-2 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800" data-hs-collapse="#navbar-collapse-with-animation" aria-controls="navbar-collapse-with-animation" aria-label="Toggle navigation">
                                    <svg className="hs-collapse-open:hidden w-4 h-4" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                    </svg>
                                    <svg className="hs-collapse-open:block hidden w-4 h-4" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div id="navbar-collapse-with-animation" className="hs-collapse hidden overflow-hidden transition-all duration-300 basis-full grow">
                            <div className=" bg-white flex flex-col gap-5 mt-5 sm:flex-row sm:items-center sm:justify-end sm:mt-0 ">
                                {meaul.map(item=><div key={item.id} className="w-[100vw] text-[2rem] font-medium text-gray-600 dark:text-gray-400 dark:hover:text-gray-500 h-[5rem] flex justify-center items-center  border-b-[1px] border-solid border-[#f0efef] last:mb-[50rem] leading-[5rem]" onClick={ ()=>{CloseHandleEvent(item)}}>{item.title}</div>)}
                            </div>
                        </div>
                    </nav>
                </header>
          </div>
          {/* <div className='h-[0]'>111</div> */}
        </>
    )
}

export default Header